import styled from 'styled-components';
export const StyledBroadsiderPromo = styled.div`
  z-index: 101;
  position: relative;
  width: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  -webkit-backdrop-filter: blur(10px);
  -moz-backdrop-filter: blur(10px);
  -ms-backdrop-filter: blur(10px);
  -o-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  height: ${({ theme }) => theme.promoScrollerHeight};
  min-height: ${({ theme }) => theme.promoScrollerHeight};
  border-top-color: white;
  margin-top: ${({ theme }) => '-' + theme.frameWidth};

  .broadsider-promo-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 2px solid rgba(0, 0, 0, 0.36);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .broadsider-promo-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .broadsider-promo-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .broadsider-promo-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .broadsider-promo-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .broadsider-promo-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .broadsider-promo-dots-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    background: ${({ theme }) => theme.background};
    bottom: 0;
    left: 50%;
    gap: calc(${({ theme }) => theme.frameWidth} / 2);
    padding : 0 calc(${({ theme }) => theme.frameWidth} / 2);
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
  }

  .broadsider-promo-dot {
    width: ${({ theme }) => theme.frameWidth};
    height: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.frame}; 
  }

  .broadsider-promo-dot-current {
    background: white;
  }

  .broadsider-promo-prev {
    background: transparent;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    width: 15%;
    height: 100%;

    &:hover {
      background: linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
      cursor: pointer;
    }
  }

  .broadsider-promo-next {
    background: transparent;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    width: 15%;
    height: 100%;
    &:hover {
      background: linear-gradient(270deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
      cursor: pointer;
    }
  }
`;
